import { render, staticRenderFns } from "./createProductLabel.vue?vue&type=template&id=5b2c076b&scoped=true"
import script from "./createProductLabel.vue?vue&type=script&lang=js"
export * from "./createProductLabel.vue?vue&type=script&lang=js"
import style0 from "./createProductLabel.vue?vue&type=style&index=0&id=5b2c076b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c076b",
  null
  
)

export default component.exports